import {Button, Card, CardContent, colors, Divider, Theme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import React, {useState} from 'react';
import {Page} from '../../components/Page';
import PageHeader from '../../components/PageHeader';
import {WCVDatePicker} from '../../components/DateUtilsProvider/WCVDatePicker';
import moment from 'moment';
import {getHost} from '../../graphql/GraphQlProvider';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(3)
    },
    divider: {
        backgroundColor: colors.grey[300]
    },
    button: {
        marginTop: theme.spacing(2)
    },
}));

const ReceiptsPerGroupDownload = () => {
    const classes = useStyles();
    const title = 'Receipts per Group';
    const [fromDate, setFromDate] = useState<string | null | undefined>(moment().startOf('month').format('YYYY-MM-DD'));
    const [toDate, setToDate] = useState<string | null | undefined>(moment().endOf('month').format('YYYY-MM-DD'));

    const isValidDate = (value?: string | null) => !!value && moment(value, 'YYYY-MM-DD', true).isValid();
    const canDownload = isValidDate(fromDate) && isValidDate(toDate);

    const download = () => {
        if (canDownload) {
            const url = getHost() + '/receipts_per_group_csv/' + btoa(JSON.stringify({from: fromDate, to: toDate}));
            window.location.assign(url);
        }
    };

    return (
        <Page className={classes.root} title={title}>
            <PageHeader section="Reports" title={title}/>
            <Divider className={classes.divider}/>
            <Card>
                <CardContent>
                    <WCVDatePicker
                        id="from_date"
                        label="From"
                        value={fromDate}
                        onChange={(date, value) => {
                            setFromDate(value);
                        }}
                    />
                    <WCVDatePicker
                        id="to_date"
                        label="To"
                        value={toDate}
                        onChange={(date, value) => {
                            setToDate(value);
                        }}
                    />
                    <Button
                        className={classes.button}
                        color="primary"
                        variant="contained"
                        disabled={!canDownload}
                        onClick={download}
                    >
                        Download CSV
                    </Button>
                </CardContent>
            </Card>
        </Page>
    );
};

export default ReceiptsPerGroupDownload;
